import { pletApiRequest } from './client';

/** SOP API — backend endpoint name kept for data compatibility; product calls these "Docs". */
export const SopAPI = {
  list: async () => {
    const result = await pletApiRequest('/sops');
    return result.sops;
  },

  get: async (sopId) => {
    const result = await pletApiRequest(`/sops/${sopId}`);
    return result.sop;
  },

  create: async (sop) => {
    const result = await pletApiRequest('/sops', {
      method: 'POST',
      body: JSON.stringify(sop),
    });
    return result.sop;
  },

  update: async (sopId, sop) => {
    const result = await pletApiRequest(`/sops/${sopId}`, {
      method: 'PUT',
      body: JSON.stringify(sop),
    });
    return result.sop;
  },

  delete: async (sopId) => {
    const result = await pletApiRequest(`/sops/${sopId}`, {
      method: 'DELETE',
    });
    return result;
  },

  deletePermanent: async (sopId) => {
    const result = await pletApiRequest(`/sops/${sopId}?permanent=true`, {
      method: 'DELETE',
    });
    return result;
  },

  restore: async (sopId) => {
    const result = await pletApiRequest(`/sops/${sopId}`, {
      method: 'PUT',
      body: JSON.stringify({ deletedAt: null, expiresAt: null }),
    });
    return result.sop;
  },
};
